import React from 'react';
import { Select, Bubble } from 'tea-component';
import EventCountInput from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent/components/EventCountInput';
import { IEventOccurCountInputItemProps } from './type';
import './index.scss';

const EventOccurCountInputItem: React.FC<IEventOccurCountInputItemProps> = ({
  value,
  onChange,
  operator,
  onOperatorChange,
  operatorEditable = false,
  operatorOptions = [],
  staticOperatorText = '≥',
  placeholder,
  error,
}) => {
  return (
    <Bubble
      visible={!!error}
      placement="top"
      error
      transitionTimeout={0}
      content={<span className="dbd-event-occur-count-item__error-text">{error}</span>}
    >
      <div className="dbd-event-occur-count-item">
        {operatorEditable ? (
          <Select
            appearance="button"
            value={operator}
            onChange={onOperatorChange}
            options={operatorOptions}
          />
        ) : (
          <span className="dbd-event-occur-count-item__operator">{staticOperatorText}</span>
        )}
        <EventCountInput
          value={value || ''}
          onChange={onChange}
          min={0}
          placeholder={placeholder}
        />
      </div>
    </Bubble>
  );
};

export default EventOccurCountInputItem;
